import { extendZodWithOpenApi } from '@anatine/zod-openapi';
import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import {
  IdentityBrowseQueryParamsSchema,
  mcpExposeMetadata,
  PresentableIdentitySummarySchema,
  ResponseMetaSchema,
} from '../models';

extendZodWithOpenApi(z);

const c = initContract();

export const apiIdentities = c.router({
  browseIdentities: {
    method: 'GET',
    path: `/1.0/identities/browse`,
    query: IdentityBrowseQueryParamsSchema,
    responses: {
      200: z.object({
        identities: z.array(PresentableIdentitySummarySchema),
        meta: ResponseMetaSchema.pick({ count: true }).extend({
          hasMore: z
            .boolean()
            .describe(
              'Whether there are more results available (derived via limit+1; avoids expensive total counts).'
            ),
        }),
      }),
    },
    summary: 'Browse imported identities for a connection',
    description:
      'Browse identities imported by a specific connection with basic filters and search. Intended for admin/debug deep browsing and contextualization (and MCP tooling in local development).',
    metadata: mcpExposeMetadata,
  },
});
